import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { CensusPatientListService } from '../census-patient-list/census-patient-list.service';

@Component({
  selector: 'app-scriptsure-email-dialog',
  templateUrl: './scriptsure-email-dialog.component.html',
  styleUrls: ['./scriptsure-email-dialog.component.css'],
  host: {
    'class': 'scriptsure-email-dialog'
  }
})
export class ScriptsureEmailDialogComponent {
  email: string = '';

  constructor(
    private censusPatientListService: CensusPatientListService,
    public dialogRef: MatDialogRef<ScriptsureEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService
  ) {
    dialogRef.addPanelClass('scriptsure-email-dialog-container');
  }

  isValidEmail(): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
  }

  async onSubmit() {
    if (this.isValidEmail()) {
      try {
        const response: any = await this.censusPatientListService.checkIfScriptSureEmailRegistered(this.email);
        if (response && response.data.registered) {
          this.dialogRef.close(this.email);
        } else {
          this.toastr.error('This email is not registered with ScriptSure. Please enter a valid ScriptSure email.');
        }
      } catch (error) {
        this.toastr.error('Failed to verify ScriptSure email. Please try again.');
        console.error('ScriptSure email verification error:', error);
      }
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
